import { createApiClient } from "@/api";
import { type DataProviderSchema } from "@/utils";
import { checkAndThrowRequiredFieldsError } from "@/utils/errors";

import { PER_PAGE } from "./constants";

const apiClient = createApiClient("jsonld");
const BASE_URL = "/api/vpn/app_version_flags";

export const appVersionFlagsSchema: DataProviderSchema<
  "AppVersionFlag",
  "jsonld"
> = {
  list: async (params) => {
    const { pagination } = params;
    const { data } = await apiClient.GET(BASE_URL, {
      params: {
        query: {
          limit: PER_PAGE,
          page: pagination?.page,
        },
      },
    });

    return {
      data: data?.["hydra:member"] ?? [],
      total: data?.["hydra:totalItems"] ?? 0,
    };
  },
  detail: async ({ id }) => {
    const { data } = await apiClient.GET(`${BASE_URL}/{id}`, {
      params: {
        path: { id: String(id) },
      },
    });

    if (!data) throw new Error("App Version Flag not found");

    return { data };
  },
  edit: async ({ id, data: { clientAppId, major, minor, patch, di } }) => {
    const requiredFields = ["clientAppId", "major", "minor", "patch", "di"];

    const body = checkAndThrowRequiredFieldsError(
      {
        clientAppId,
        major,
        minor,
        patch,
        di: di ? true : false,
      },
      requiredFields,
    );
    const { data } = await apiClient.PUT(`${BASE_URL}/{id}`, {
      params: {
        path: { id: String(id) },
      },
      body,
    });

    if (!data) throw Error("Something went wrong");

    return { data };
  },
  create: async ({ data: { clientAppId, major, minor, patch, di } }) => {
    const requiredFields = ["clientAppId", "major", "minor", "patch", "di"];

    const body = checkAndThrowRequiredFieldsError(
      {
        clientAppId,
        major,
        minor,
        patch,
        di: di ? true : false,
      },
      requiredFields,
    );

    const { data } = await apiClient.POST(BASE_URL, {
      body,
    });

    if (!data) throw Error("Something went wrong");

    return {
      data,
    };
  },
  delete: async ({ id }) => {
    const { data } = await apiClient.DELETE(`${BASE_URL}/{id}`, {
      params: {
        path: { id: String(id) },
      },
    });
    return {
      data,
    };
  },
};
